import { showDesktopNotification } from "../notifications/desktopNotification";
import {
  startIncomingCallRingtone,
  stopIncomingCallRingtone,
} from "../notifications/soundUtils";

let titleTimer = null;
let originalTitle = null;

export function startIncomingCallTitleFlash(label = "Ligação entrando") {
  if (typeof document === "undefined") return;
  if (titleTimer) return;
  originalTitle = document.title;
  let on = false;
  titleTimer = window.setInterval(() => {
    on = !on;
    document.title = on ? label : originalTitle || document.title;
  }, 800);
}

export function stopIncomingCallTitleFlash() {
  if (titleTimer) {
    window.clearInterval(titleTimer);
    titleTimer = null;
  }
  if (originalTitle != null && typeof document !== "undefined") {
    document.title = originalTitle;
  }
  originalTitle = null;
}

export function startIncomingCallAttention({
  title = "Ligação entrando",
  body = "Há uma ligação no Xpro.",
  url = "/chat?voice=1",
  tag = "xpro-voice-incoming",
} = {}) {
  startIncomingCallRingtone();
  startIncomingCallTitleFlash(title);
  const hidden =
    typeof document !== "undefined" &&
    (document.visibilityState === "hidden" || document.hidden || !document.hasFocus());
  if (hidden) {
    void showDesktopNotification({ title, body, tag, url });
  }
}

export function stopIncomingCallAttention() {
  stopIncomingCallRingtone();
  stopIncomingCallTitleFlash();
}
